<template>
  <transition>
    <div v-if="message !== null" class="o-message-banner">
      <div class="o-container o-container--xlarge message-banner-inner">
        <div class="message-banner-message">
          <font-awesome-icon icon="info-circle" />
          {{ message }}
        </div>
        <div class="message-banner-cta">
          <bos-button color="white-on-red" small @click.prevent="close">
            {{ $t('components.messagebanner.cta') }}
          </bos-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import BosButton from '../components/BosButton'

export default {
  name: 'MessageBanner',
  data() {
    return {
      messageDelaLapsed: false,
      messageDelay: 1.5,
      message: null
    }
  },
  props: {
    store: {
      type: Object
    }
  },
  computed: {
    messages() {
      return this.$store.getters['messages/get']
    }
  },
  methods: {
    close() {
      this.message = null
    },
    displayMessage() {
      this.$store.dispatch('setMessage', null)
      this.messageDelaLapsed = false
      setTimeout(() => {
        this.messageDelaLapsed = true
      }, this.messageDelay * 1000)
    }
  },
  created() {
    if (this.$store.state.message == null) {
      this.message = null
    } else {
      this.message = this.$t(this.$store.state.message)
    }

    this.displayMessage()
  },
  watch: {
    '$store.state.message'() {
      if (this.$store.state.message !== null) {
        this.message = this.$t(this.$store.state.message)
        this.displayMessage()
      }
    }
  },
  components: {
    BosButton
  }
}
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';

$notificaton-banner-inner-padding-y: 0.5em !default;
$notificaton-banner-inner-bg: $brand-red !default;
$notificaton-banner-inner-font-size: 1em !default;
$notificaton-banner-inner-font-weight: $font-weight-bold !default;
$notificaton-banner-inner-color: $brand-white !default;

$message-banner-inner-transition-duration: 450ms !default;

$message-banner-mobile-inner-cta-margin: 0.5em !default;

.o-message-banner {
  height: 0;

  .message-banner-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding-top: $notificaton-banner-inner-padding-y;
    padding-bottom: $notificaton-banner-inner-padding-y;
    background-color: $notificaton-banner-inner-bg;
    font-size: $notificaton-banner-inner-font-size;
    font-weight: $notificaton-banner-inner-font-weight;
    color: $notificaton-banner-inner-color;
  }

  &.v-enter,
  &.v-leave-to {
    .message-banner-inner {
      transform: translateY(-100%);
    }
  }

  &.v-enter-to,
  &.v-leave {
    .message-banner-inner {
      transform: translateY(0%);

      &:before {
        display: block;
        content: '';
        position: absolute;
        bottom: 100%;
        left: 0;
        right: 0;
        height: 100%;
        background-color: inherit;
      }
    }
  }

  &.v-enter-active {
    transition: $message-banner-inner-transition-duration;

    .message-banner-inner {
      animation: bounce-in $message-banner-inner-transition-duration;
    }
  }

  &.v-leave-active {
    transition: $message-banner-inner-transition-duration;

    .message-banner-inner {
      transition: all $message-banner-inner-transition-duration ease-out;
    }
  }

  .md &,
  .sm &,
  .xs & {
    .message-banner-inner {
      display: block;

      .message-banner-cta {
        margin-top: $message-banner-mobile-inner-cta-margin;
      }
    }
  }

  @keyframes bounce-in {
    0% {
      transform: translateY(-100%);
    }
    60% {
      transform: translateY(10%);
    }
    100% {
      transform: translateY(0%);
    }
  }
}
</style>
